import React, { Component } from 'react';
import { Input, Modal, Button, message, Spin, Icon } from 'antd';
import TableC from '../../../basicElement/TableC';
import CascaderCity from '../../../common/CascaderCity';
import AssignEmployee from './AssignEmployee';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const DefaultPagination = {
    current: 1,
    pageSize: 10,
};

class TransferProcess extends Component {
    state = {
        visible: false,
        loading: false,
        employeesLoading: false,
        requirementCode: undefined,
        fteList: [],
        city: '',
        employees: [],
        processList: [],
        rejectHistory: [],
        userOptions: [],
        handle: "handle",
        reRender: true,
        pagination: { ...DefaultPagination },
        searchParams: {},
    };

    show = (params = {}, handle) => {
        this.setState({
            visible: true,
            requirementCode: undefined,
            handle,
            searchParams: params,
            pagination: { ...DefaultPagination },
        }, () => {
            const { requirementId } = params;
            requirementId && this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            reRender: false,
            fteList: [],
            processList: [],
            employees: [],
            rejectHistory: [],
        }, () => {
            this.setState({
                reRender: true,
            })
        });
    }

    prospectiveAssign = (processList) => {
        const { searchParams } = this.state;
        
        const params = {};
        processList.forEach((u, i) => {
            params[`ids[${i}]`] = u.userId;
        });

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.prospectiveAssign,
            data: {
                ...params,
                ...searchParams,
            },
            doneResult: () => {
                this.setState({
                    processList,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    process = user => {
        const { processList } = this.state;
        processList.push(user);
        this.prospectiveAssign(processList);
    }

    removeProcess = (user) => {
        const { processList } = this.state;
        const index = (processList || []).findIndex(i => i.userId == user.userId);
        processList.splice(index, 1);

        this.prospectiveAssign(processList);
    }

    handleSubmit = () => {
        const { processList, searchParams: { requirementId } } = this.state
        const params = {};
        processList.forEach((item, index) => {
            params[`ids[${index}]`] = item.userId;
            params[`intDate[${item.userId}]`] = item.entryDate;
        });
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.assignEmployee,
            data: {
                ...params,
                requirementId,
            },
            doneResult: () => {
                this.setState({
                    loading: false,
                    reRender: true,
                }, () => {
                    this.setState({ reRender: true });
                });
                message.success('分派成功');
                this.props.reload();
                this.hide();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.fteSettleInfo,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams
            },
            doneResult: res => {
                const { city, fteList, employees, rejectHistory, requirementCode, totalCount } = res.data || {};
                pagination.total = totalCount;
                (employees || []).forEach(item => {
                    item.hasProcess = false;
                    item.processHtml = '分派';
                });
                this.setState({
                    city,
                    fteList,
                    employees,
                    rejectHistory,
                    requirementCode,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns_processHistory = () => {
        const columns = [{
            title: '分派时间',
            dataIndex: 'processTime',
            key: 'processTime',
        }, {
            title: '分派人员',
            dataIndex: 'processUser',
            key: 'processUser',
            render: (text, record) => {
                const { processUser } = record;
                return (
                    <span>
                        {
                            processUser.map((item, index, array) => {
                                const { userId, userName, employeeCode } = item;
                                return (
                                    <a onClick={() => this.props.showEmployeeDetail(userId, employeeCode, userName)}>
                                        {userName}({employeeCode}){array.length > 1 ? ';' : ''}
                                    </a>
                                );
                            })
                        }
                    </span>
                );
            }
        }, {
            title: '时间',
            dataIndex: 'refuseTime',
            key: 'refuseTime',

        }, {
            title: '原因',
            dataIndex: 'refuseReason',
            key: 'refuseReason',
        }];
        return columns;
    }

    getColumns_requirement = () => {
        const { fteList } = this.state;

        const columns = [{
            title: '时间',
            dataIndex: 'time',
            key: 'time',
            fixed: 'left',
            width: 60
        }];
        (fteList || []).forEach((fte, i) => {
            const time = `${fte.year}.${fte.month}`;
            columns.push({
                title: time,
                dataIndex: time,
                key: time,
                width: 60
            });
        });
        return columns;
    }

    getColumns_employees = () => {
        const { fteList = [], processList } = this.state;

        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            fixed: 'left',
            render: (text, record) => {
                const { userId, userName, employeeCode, } = record;
                return <a onClick={() => this.props.showEmployeeDetail(userId, employeeCode, userName)}>{employeeCode}</a>;
            },
        }, {
            title: '姓名',
            dataIndex: 'userName',
            key: 'userName',
            width: 80,
            fixed: 'left',
        }, {
            title: '休假情况',
            dataIndex: 'vacationValue',
            key: 'vacationValue',
            width: 200,
        }];
        fteList.forEach((fte, i) => {
            const time = `${fte.year}.${fte.month}`;
            columns.push({
                title: time,
                children: [{
                    title: '已分配',
                    dataIndex: `${time}_fte`,
                    key: `${time}_fte`,
                    width: 60,
                }, {
                    title: '预分配',
                    dataIndex: `${time}_pfte`,
                    key: `${time}_pfte`,
                    width: 60,
                }],
            });
        });
        columns.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (text, record) => {
                const hasProcess = (processList || []).some(i => i.userId == record.userId);
                return (
                    hasProcess ?
                        <a disabled={true}>已分派</a>
                        :
                        <a onClick={() => this.showAssignEmployee(record)}>分派</a>
                )
            }
        });
        return columns;
    }

    getDataSource_processHistory = () => {
        return (this.state.rejectHistory || []).map(i => ({
            processTime: i.relateTime,
            refuseTime: i.createTime,
            refuseReason: i.remark,
            processUser: i.assignmentList,
            id: i.requirementTransactionId,
        }));
    }

    getDataSource_requirement = () => {
        const ftes = [];
        const { fteList = [] } = this.state;
        const fte_temp = {};
        fte_temp.time = 'FTE';
        fte_temp.id = 1;
        fteList.map((fte, i) => {
            const time = `${fte.year}.${fte.month}`;
            fte_temp[time] = fte.fte && fte.fte.toFixed(2);
        });
        ftes.push(fte_temp);
        return ftes;
    }

    getDataSource_employees = () => {
        return (this.state.employees || []).map((employee, i) => {
            const { fteList, vacationValue } = employee;
            if ((vacationValue || '').indexOf(',') > -1) {
                employee.vacationValue = vacationValue.split(',').map(a => (
                    <span>{a};<br /></span>
                ));
            }

            (fteList || []).forEach(fte => {
                const time = `${fte.year}.${fte.month}`;
                employee[`${time}_fte`] = fte.fte;
                employee[`${time}_pfte`] = fte.pfte;
            });
            return employee;
        });
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    handleCascaderCityChange = (value, selectedOptions) => {
        const { searchParams } = this.state;
        const [provinceId, workCityId] = value || [];
        searchParams.provinceId = provinceId;
        searchParams.workCityId = workCityId;
        this.setState({ searchParams });
    }

    showAssignEmployee = record => {
        this.assignEmployeeRef.show(record);
    }

    render() {
        const {
            city,
            visible,
            pagination,
            processList,
            employeesLoading,
            rejectHistory,
            loading,
            handle,
            reRender,
            requirementCode,
            searchParams: {
                keyword,
                workCityId,
                provinceId,
                handoverReasonShow,
                status
            },
        } = this.state;
        const title = handle == "handle" ? "交接任务处理" : "交接任务重新处理";
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 600 }}
                confirmLoading={loading}
                maskClosable={false}
                width="1000px"
            >
                <Spin spinning={loading}>
                    <div>
                        {/* <div style={{ fontSize: '16px' }}>{title}</div> */}
                        <div style={{ marginTop: 16 }}>交接编号：{requirementCode}<span style={{ marginLeft: 10 }}>城市：</span>{city}</div>
                    </div>
                    {   
                        (status == 'NEW' || status == 'REJECTED' || status == 'HANDOVER_RECALL') &&
                        <div style={{ marginTop: 24, lineHeight: '34px', borderTop: '1px solid #d1d1d1' }}>交接原因：{handoverReasonShow}</div>
                    }
                    {
                        rejectHistory && rejectHistory.length > 0 &&
                        <div style={{ marginTop: 24, paddingTop: 10, lineHeight: '34px', borderTop: '1px solid #d1d1d1' }}>
                            <label>分派历史记录</label>
                            <div className="content">
                                <TableC
                                    columns={this.getColumns_processHistory()}
                                    data={this.getDataSource_processHistory()}
                                    className="processHistory"
                                    rowKey="id"
                                />
                            </div>
                        </div>
                    }
                    <div style={{ lineHeight: '34px', borderTop: '1px solid #d1d1d1' }}>交接任务未来预计占用FTE明细</div>
                    <div className="content">
                        <TableC
                            columns={this.getColumns_requirement()}
                            data={this.getDataSource_requirement()}
                            className="requirement_detail"
                            rowKey="id"
                        />
                    </div>
                    <div style={{ marginTop: 24, paddingTop: 10, borderTop: '1px solid #d1d1d1' }}>
                        <div style={{ display: "block", marginBottom: 10, overflow: 'hidden' }}>
                            <label style={{ lineHeight: "38px" }}>
                                符合需求人员-已被占用FTE情况
                            </label>
                            <div className="filter-bar" style={{ float: "right" }}>
                                <div className="form-item">
                                    <label className="ui-label">工作城市</label>
                                    {
                                        reRender &&
                                        <CascaderCity
                                            style={{ width: 125 }}
                                            value={workCityId ? [provinceId, workCityId] : []}
                                            onChange={(value, selectedOptions) => this.handleCascaderCityChange(value, selectedOptions)}
                                        />
                                    }
                                </div>
                                <div className="form-item">
                                    <label className="ui-label">人员</label>
                                    <Input
                                        placeholder="请输入工号\姓名"
                                        onChange={e => this.handleInputChange(e, 'keyword')}
                                        value={keyword}
                                    />
                                </div>
                                <Button type="primary" onClick={this.search}>搜索</Button>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <TableC
                            className="employees-table"
                            columns={this.getColumns_employees()}
                            data={this.getDataSource_employees()}
                            pagination={pagination}
                            rowKey="userId"
                            reRenderTime={400}
                            loading={employeesLoading}
                            onChange={this.handleTableChange}
                        />
                    </div>
                    <div className="process_list">
                        <div style={{ position: 'absolute' }}>分派人员：</div>
                        <div style={{ marginLeft: 60, overflow: 'hidden' }}>
                            {processList.map(item => (
                                <div className="process_item" key={item.employeeCode}>
                                    {item.userName}({item.employeeCode})
                                    <span style={{ marginLeft: 10 }}>【人员到位时间：{item.entryDate}】</span>
                                    <Icon
                                        className="icon"
                                        type="close-circle"
                                        onClick={() => this.removeProcess(item)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Spin>
                <AssignEmployee ref={el => this.assignEmployeeRef = el} process={this.process} />
            </Modal>
        );
    }
}

export default TransferProcess;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/TransferProcess.js